const productTile = require('site/product/productTile');
const scrollAnimate = require('base/components/scrollAnimate');

function goToPage(e) {
    const $this = $(this);
    const url = $this.data('url');

    if (!url) {
        return;
    }

    const $results = $('.js-search-results');

    $.spinner().start();
    $(this).trigger('search:showMore', e);
    $.ajax({
        url,
        data: { selectedUrl: url },
        method: 'GET',
    })
        .done((response) => {
            productTile.destroy();
            $results.html(response);
            scrollAnimate($results);
            productTile.init();
        })
        .always(() => {
            $.spinner().stop();
        });
}

function toggleActiveBullet() {
    $('.js-bullet-page').removeClass('active');
    $(this).addClass('active');
}

function bindEvents() {
    $(document).on('click', '.js-goto-page', goToPage);
    $(document).on('click', '.js-bullet-page', toggleActiveBullet);
}

module.exports = {
    bindEvents,
};
